import {
  HeroWrapper,
  FloatingIcon,
  DJImage,
  NeonPink,
  NeonBlue,
  MotionSubtitle,
  MotionTitle,
  MotionDescriptionBlock,
  MotionDescription,
  HeroImageBlock,
  HeroTextBlock,
} from "./HeroSectionStyles";

import Play from "../../img/play.svg";
import Music from "../../img/music.svg";
import Star from "../../img/star.svg";
import DJ from "../../img/dj.png";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { fadeUp } from "../../styles/animations";
import ButtonGradient from "../ui/ButtonGradient";

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <HeroWrapper>
      <HeroTextBlock>
        <MotionSubtitle
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }}
          custom={0}
        >
          Leve seu som para o próximo nível
        </MotionSubtitle>

        <MotionTitle
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.1 }}
          custom={1}
        >
          Crie seu press kit profissional em minutos
        </MotionTitle>

        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.1 }}
          custom={2}
        >
          <ButtonGradient onClick={() => navigate("/login")}>
            Monte o seu!
          </ButtonGradient>
        </motion.div>

        <MotionDescriptionBlock
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }}
          custom={3}
        >
          Seu palco começa aqui: <br />
          Transforme sua <NeonPink>música</NeonPink> em{" "}
          <NeonBlue>oportunidade</NeonBlue>, compartilhe seu talento e
          destaque-se com um portfólio profissional!
        </MotionDescriptionBlock>

        <MotionDescription
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.1 }}
          custom={4}
        >
          Descubra uma forma revolucionária de apresentar sua carreira musical!
          O Press Kit é a plataforma ideal para DJs criarem portfólios
          personalizados e profissionais. Nosso objetivo é conectar DJs a
          contratantes de forma prática, moderna e eficiente.
        </MotionDescription>
      </HeroTextBlock>

      <HeroImageBlock>
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.1 }}
          custom={5}
        >
          <DJImage src={DJ} alt="DJ criando música" />
        </motion.div>

        {/* Ícones flutuantes */}
        <FloatingIcon className="icon-play">
          <img src={Play} alt="Play" width={48} height={48} />
        </FloatingIcon>
        <FloatingIcon className="icon-music">
          <img src={Music} alt="Música" width={48} height={48} />
        </FloatingIcon>
        <FloatingIcon className="icon-star">
          <img src={Star} alt="Estrela" width={48} height={48} />
        </FloatingIcon>
      </HeroImageBlock>
    </HeroWrapper>
  );
};

export default HeroSection;
